import React, { useState, useEffect } from 'react';
import { NumberInput, Tooltip } from 'components/common';
import { useForm  } from "react-hook-form";

const DelayedNumberFormField = ({ name, value, setValue, integerOnly }) => {
  const [inputValue, setInputValue] = useState(value);
  const {register, handleSubmit, clearErrors, trigger, formState: { errors }} = useForm();

  const handleDelayedInputValue = (v) => {
    setValue( () => v )
  }

  useEffect(() => {
    const timeOutId = setTimeout(() => handleDelayedInputValue(inputValue), 500);
    return () => clearTimeout(timeOutId);
  }, [inputValue]);

  return <NumberInput
    name={name}
    placeholder="count"
    register={register}
    errors={errors}
    class_name="some-class-name"
    integerOnly={integerOnly}
    validators={[]}
    value={inputValue}
    onChange={event => setInputValue(event.target.value)}
  />
}

export default DelayedNumberFormField;
